/* istanbul ignore file */

// declarative file
export enum FileInputLabel {
  PJ = 'Ajouter une pièce jointe',
  SCREEN = 'Joindre une capture d’écran',
  PROFIL = 'Merci de nous transmettre la capture d’écran des informations personnelles de votre profil',
}
